<template>
  <crud-layout
    :title="$t('listaPreciosVenta.title')"
    :subtitle="$t('listaPreciosVenta.subtitle')"
    :add-button="true"
    @add="create"
  >
    <template v-slot:list>
      <lista-precios-venta-list
        ref="list"
        @update="update"
        @delete="remove"
      />
    </template>

    <lista-precios-venta-create
      v-if="creating"
      :open="creating"
      @itemCreated="onItemCreated"
      @close="creating = false"
    />

    <lista-precios-venta-update
      v-if="updating"
      :open="updating"
      :item="itemToEdit"
      @itemUpdated="onItemUpdated"
      @close="updating = false"
    />

    <lista-precios-venta-delete
      v-if="deleting"
      :open="deleting"
      :item="itemToDelete"
      @itemDeleted="onItemDeleted"
      @close="deleting = false"
    />

    <snackbar v-model="flash" />
  </crud-layout>
</template>

<script>
import ListaPreciosVentaList from "../ListaPreciosVentaList";
import ListaPreciosVentaCreate from "../ListaPreciosVentaCreate";
import ListaPreciosVentaUpdate from "../ListaPreciosVentaUpdate";
import ListaPreciosVentaDelete from "../ListaPreciosVentaDelete";
import { CrudLayout, Snackbar } from "@dracul/common-frontend";

export default {
  name: "ListaPreciosVentaCrud",
  components: {
    CrudLayout,
    Snackbar,
    ListaPreciosVentaList,
    ListaPreciosVentaCreate,
    ListaPreciosVentaUpdate,
    ListaPreciosVentaDelete,
  },
  data() {
    return {
      flash: null,
      creating: false,
      updating: false,
      deleting: false,
      itemToEdit: null,
      itemToDelete: null,
    };
  },
  methods: {
    onItemCreated() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.created");
    },
    onItemUpdated() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.updated");
    },
    onItemDeleted() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.deleted");
    },
    create() {
      this.creating = true;
    },
    update(item) {
      this.updating = true;
      this.itemToEdit = item;
    },
    remove(item) {
      this.deleting = true;
      this.itemToDelete = item;
    },
  },
};
</script>
